var SLOVERS = SLOVERS || {};
(function($){

  // USE STRICT
  "use strict";
  var addToCart, addToCartFail, addToCartPass, cart_dropdown_timer, current_window, fadeOutCartDropdown, log;
  var $el, $productWrapper, $productImages, $productImage, $productImagesCount, $productDetails, $productDetailsClone;
  log = function(value) {
    if (typeof console !== "undefined") {
      return console.log(value);
    }
  };

  SLOVERS.initialize = {
    init: function(){
      SLOVERS.initialize.sameHeight();
      SLOVERS.initialize.header();
      SLOVERS.initialize.megaMenu();
      SLOVERS.initialize.cleverFilter();
      SLOVERS.initialize.sendEnquireMail();
      SLOVERS.initialize.mainDisplayDimensions();
      SLOVERS.initialize.stickyElements();
      SLOVERS.initialize.bannerVideo();
      SLOVERS.initialize.lazyLoading();
      SLOVERS.initialize.miniSearchDrawer();
      SLOVERS.initialize.backToTop();
      SLOVERS.initialize.customFunction();
      SLOVERS.initialize.customTap();
      SLOVERS.initialize.resizeProductDetails();
      //SLOVERS.initialize.repositionProductDetails();
      SLOVERS.initialize.swatch();
      SLOVERS.initialize.redirectFabric();

    },
    header: function(){
      if ($(window).width() > 1024) {
        var FreeShipHeight = $(".free-ship").outerHeight();
      }
      else {
        var FreeShipHeight = $(".free-ship").outerHeight();
      }
      var FreeShipHeight = $(".free-ship").outerHeight();
      var HeaderHeight = $("header").outerHeight();
      var HeaderTotalHeight = FreeShipHeight + HeaderHeight;

      $(window).scroll(function() {
        if ($(window).scrollTop() > FreeShipHeight) {
          $('header').addClass('sticky-header');
        }
        else {
          $('header').removeClass('sticky-header');
        }
      });
      $('header').scrollToFixed();
    },

    headerSpacing: function() {
      var FreeShipHeight = $(".free-ship").outerHeight();
      if ($.cookie('notificationBar') == 'closed') {
        $('.notification-bar').remove();
        $(".message-bar header").css({'top': 0});
        $("header.hd").css({'top': 0});
        FreeShipHeight = 0;
      }
      var HeaderHeight = $("header").outerHeight();
      var HeaderTotalHeight = FreeShipHeight + HeaderHeight;
      /*if($('body').hasClass('template-index')) {
        if ($(window).width() < 981 ){
          $("body.homepage-front.message-bar").css({'padding-top': FreeShipHeight});
          $(".message-bar header").css({'top': FreeShipHeight});
        }
      }
      else if ($(window).width() < 981 ) {
        $("body.message-bar").css({'padding-top': HeaderTotalHeight});
        $(".message-bar header").css({'top': FreeShipHeight});
      }
      else if($("body").not('.template-index') && $(window).width() > 981) {
        $("body").removeAttr("style");
      }*/
    },
    stickyElements: function(){
      if(theme.template == 'index') {}
      if(windowWidth > 1024) {
        $('#sticky').scrollToFixed({ marginTop: $header.outerHeight(true) });
      }
    },
    mainDisplayDimensions: function() {
      if( $mainDisplayEl.find('.full-image-section').length < 1 ) { return true; }
      var navspace = windowHeight / 1.77;
      if(windowWidth > 768) {
        var navspace = 85;
      }
      //var firstViewHeight = windowHeight - navspace;
      var firstViewHeight = windowHeight;
      //console.log(windowHeight);
      $('.full-image-section').css('height', firstViewHeight);
    },
    sameHeight: function(){
      DOC.find('.same-height').matchHeight();
    },
    megaMenu: function() {
      $(".is-mega .mega-menu .item").hoverIntent(function() {
        var e = $(this), t = e.closest(".mega-menu").find(".item"), c = e.find(".mega-menu-content"),i = e.find(".mega-menu-content > .wrap");
        t.removeClass("hover"), e.addClass("hover"), c.removeClass("hide"), i.fadeIn(400, function() {
          var t = e.closest(".mega-menu").find(".item:not(.hover) .mega-menu-content > .wrap");
          t.hide()
          })
        })
    },
    filter_tag_strip: function(href_str,tag_str){
      //get the tag list
      var slashes = href_str.split("/");
      var tags = slashes.pop().split("+");
      var newtags = [];

      for (var index = 0; index < tags.length; ++index) {
        if (tags[index]!=tag_str){
          newtags.push(tags[index]);
        }
      }
      //rebuild and return
      return slashes.join("/")+ "/" + newtags.join("+");
    },
    cleverFilter: function(){
      if ($body.hasClass('template-collection')) {
        if (coll_var.filters.length < 1 ){return true;}
        var clvrFilter = coll_var.filters.split('|');
        clvrFilter.shift();
        $('.disabled').click(function(e){
          e.preventDefault();
          return false;
        });
        $.each(clvrFilter, function(i, v){
          var loopVar = v.split('#');
          var filter_class = loopVar[0];
          var filter_current_tag = loopVar[1];
          filter_class = 'ul.' + filter_class + ' li a';
          $(filter_class).each(function(){
            this.href = SLOVERS.initialize.filter_tag_strip(this.href,filter_current_tag);
          });
        });
      }
    },

    redirectFabric: function(){
      var dstyp = $('main .container').data('section-type');
      if (dstyp == 'product'){
        var dsid = $('main .container').data('section-id');
        var productSingleObject = JSON.parse(document.getElementById('ProductJson-' + dsid).innerHTML);
        if(productSingleObject.type.includes('fabric')) {
          window.location.href = '/collections/fabric-gallery';
        };
      }
    },
    bannerVideo: function(){

      var $video = $("#bannerSlideshowVideo");

      if ($video.length) {
        var videoId = $video.attr('data-id'),
        youtubeLoaded = false,
        videos = {};
        var videoPlayers = [];
        var videoOptions = {
          ratio: 16 / 9,
          playerVars: {
            // eslint-disable-next-line camelcase
            iv_load_policy: 3,
            modestbranding: 1,
            autoplay: 0,
            controls: 0,
            showinfo: 0,
            wmode: 'opaque',
            branding: 0,
            autohide: 0,
            rel: 0
          }
        };
        //console.log(videoId);

        videos[$video.attr('id')] = {
          id: $video.attr('id'),
          videoId: $video.data('id'),
          type: $video.data('type'),
          status: $video.data('type') === 'chrome' ? 'closed' : 'background', // closed, open, background
          videoSelector: $video.attr('id'),
          controls: $video.data('type') === 'background' ? 0 : 1,
          slideshow: $video.data('slideshow')
        };
        //console.log(videos);

        if (!youtubeLoaded) {
          // This code loads the IFrame Player API code asynchronously.
          var tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          var firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }

        /*var player;
        function onYouTubeIframeAPIReady() {
          player = new YT.Player('player', {
            height: '390',
            width: '640',
            videoId: 'M7lc1UVf-VE',
            events: {
              'onReady': onPlayerReady,
              'onStateChange': onPlayerStateChange
            }
          });
        }


        var args = $.extend({}, videoOptions, videos[videoId]);
        args.playerVars.controls = args.controls;
        videoPlayers[key] = new YT.Player(videoId, args);*/
        //console.log(videoPlayers);
      }
    },
    lazyLoading: function() {
      $("img.lazy").lazyload({threshold : 500});
      $('.products-autoload').imagesLoaded().always( function( instance ) {
        SLOVERS.initialize.sameHeight();
        $('.products-autoload li').removeClass('hidden');
      });
      // Ajax Pagination auto load.
      var pInfScrLoading = false;
      var pInfScrDelay = 250;
      function pInfScrExecute() {
        var pInfScrNode = $('.more').last();
        var pInfScrURL = $('.more a').last().attr("href");
        if(pInfScrNode.length > 0 && pInfScrNode.css('display') != 'none') {
          $.ajax({
            type: 'GET',
            url: pInfScrURL,
            beforeSend: function() {
              pInfScrLoading = true;
              pInfScrNode.clone().empty().insertAfter(pInfScrNode).append('<img src=\"//cdn.shopify.com/s/files/1/0068/2162/assets/loading.gif?105791\" />');
              pInfScrNode.hide();
            },
            success: function(data) {
              // remove loading feedback
              pInfScrNode.next().remove();
              pInfScrNode.remove();
              $('body,html').stop(true);
              var filteredData = $(data).find(".product");
              var filteredMoreData = $(data).find(".more");
              filteredData.insertBefore( $("#product-list-foot") );
              filteredMoreData.insertAfter( $("#product-list-foot") );
              pInfScrLoading = false;
              $("img.lazy").lazyload({threshold : 500});
              //SLOVERS.initialize.sameHeight();
              /*$('.products-autoload').imagesLoaded().always( function( instance ) {
                SLOVERS.initialize.sameHeight();
                $('.products-autoload li').removeClass('hidden');
              });*/
              //$('li.singleproduct').setAllToMaxHeight();
              attachClickEvent();
            },
            dataType: "html"
          });
        }
      }
      function attachClickEvent(){
        /*setTimeout(function() {
          SLOVERS.initialize.sameHeight();
        }, 5000);*/
        $('.more a').click(function(event){
          pInfScrExecute();
          event.stopPropagation();
          return false;
        });
        return false;
      }
      function autoScrollItem(event){
          pInfScrExecute();
          event.stopPropagation();
          return false;
      }
      attachClickEvent();
      if ($body.hasClass('template-collection') || $body.hasClass('template-search')){
        $(window).on('scroll', $.debounce(250, function() {
          if($(document).height() - 800 < ($(document).scrollTop() + $(window).height())) {
            var pInfScrNode = $('.more').last();
            if (typeof pInfScrNode != 'undefined' && pInfScrNode) {
              $('.more a').last().trigger("click").remove();
            }
          }
        }));
      }
    },


    customScroll: function(){
        $body.addClass("body-fade");
        $miniCartBlock.css({'margin-right': '0px'});
        SLOVERS.initialize.customShiftOpen('left');
    },
    customShiftOpen: function(direction){
        if ($(window).width() > 767 ) {
          if (direction == 'left') {
            $body.css(direction, '-520px');
            $("header").css(direction, '-520px');
          } else {
            $body.css(direction, '-520px');
            $("header").css(direction, '-520px');
          }
        }
        else if($(window).width() < 480 ) {
          if (direction == 'left') {
            $body.css(direction, '-100%');
            $("header").css(direction, '-100%');
          } else {
            $body.css(direction, '-100%');
            $("header").css(direction, '-100%');
          }
        }
        else {
          if (direction == 'left') {
            $body.css(direction, '-75%');
            $("header").css(direction, '-75%');
          } else {
            $body.css(direction, '-75%');
            $("header").css(direction, '-75%');
          }
        }
    },
    customShiftClose: function(direction){
      $body.css(direction, '0');
      $("header").css(direction, '0');
    },
    miniSearchDrawer: function(){
      // Search poup show
      $searchItem.on('click', function(e) {
        e.preventDefault();
        $body.addClass("body-fade");
        $miniSearchBlock.css({'margin-right': '0px'});
        $body.css({'left': '-500px'});
        $("header").css({'left': '-520px'});
        $('.slideshow').slick('slickPause');
      });

      /*$miniSearchBlock.on('mouseleave', function() {
        $body.removeClass('body-fade');
        $miniSearchBlock.css({'margin-right': '-520px'});
        $body.css({'left': '0'});
        $("header").css({'left': '0'});
        return true;
      });*/

      $('.minisearch-popup-cancel').on('click', function(e) {
        e.preventDefault();
        $body.removeClass('body-fade');
        $miniSearchBlock.css({'margin-right': '-520px'});
        $body.css({'left': '0'});
        $("header").css({'left': '0'});
        $('.slideshow').slick('slickPlay');
        return true;
      });
    },
    resizeProductDetails:function(){
      $el = $('.product-template'),
      $productWrapper = $('.product-wrapper', $el),
      $productImages = $('.product-images-wrap', $el),
      $productImage = $('.product-image', $el),
      $productImagesCount = $('.product-image', $el).length,
      $productDetails = $('.product-description', $el);
      if($window.width() < 981) {
        //$productDetails.removeClass('product-details-absolute').removeClass('product-details-hidden');
        //$productDetails.css('width', 'inherit');
        return;
      }
      if (!$el.length) {
        return;
      }
      //$productDetailsClone = '';
      var $productDetailspos = $('.product-details', $el);
      var shouldPositionDetailsRelative = $productImages[0].getBoundingClientRect().height < $productDetails[0].getBoundingClientRect().height;
      //console.log("shouldPositionDetailsRelative: " + shouldPositionDetailsRelative);
      if (shouldPositionDetailsRelative) {
        //$productDetails.addClass('product-details-relative').removeClass('product-details-absolute').removeClass('product-details-hidden');
        if($('.mobile-hide').length > 0) {
          //console.log('hide dots');
          $('.mobile-hide').addClass('hide');}
        if ($productDetailsClone) {
          //$productDetailsClone.addClass('product-details-hidden');
        }
      } else {
        if (!$productDetailsClone) {
          $productDetailsClone = $productDetails.clone();
          //$productDetailsClone.removeClass('product-details-relative').removeClass('product-details-absolute').addClass('product-details-fixed').addClass('product-details-clone');
          //$productDetailsClone.removeClass('product-details-relative').removeClass('product-details-absolute').addClass('product-details-fixed').addClass('product-details-clone').appendTo($productDetailspos);
        if($('.mobile-hide').length > 0) {
          //console.log('show dots');
          $('.mobile-hide').removeClass('hide');
        }
        }
        //$productDetails.removeClass('product-details-relative').addClass('product-details-absolute').addClass('product-details-hidden');
        //$productDetailsClone.removeClass('product-details-absolute').removeClass('product-details-hidden');
        //$productDetails.css('width', $('.col-right')[0].getBoundingClientRect().width);
        //$productDetailsClone.css('width', $('.col-right')[0].getBoundingClientRect().width);
      }
    },
    repositionProductDetails: function(){
      if($window.width() < 981) {
        return
      }
      if ($body.hasClass('template-product')) {
        $el = $('.product-template'),
        $productWrapper = $('.product-wrapper', $el),
        $productImages = $('.product-images-wrap', $el),
        $productImage = $('.product-image', $el),
        $productImagesCount = $('.product-image', $el).length,
        $productDetailsClone = $('.product-details-clone', $el),
        $productDetails = $('.product-description', $el);
        if ($productDetails.hasClass('product-details-relative')) {
          return;
        }
        if (!$productDetailsClone.length) {
          SLOVERS.initialize.resizeProductDetails();
        }
        if($('.mobile-hide').length > 0) {$('.mobile-hide').removeClass('hide');}
        if ($productDetailsClone.length) {
          var productImagesBottom = window.pageYOffset + $productImages[0].getBoundingClientRect().bottom;
          var productDetailBottom = window.pageYOffset + $productDetailsClone[0].getBoundingClientRect().bottom;
          if (productDetailBottom >= productImagesBottom) {
            if ($('.mobile-hide').length > 0) {
              //console.log('show dots');
              $('.mobile-hide').addClass('hide');
            }
            //$productDetails.removeClass('product-details-hidden');
            //$productDetailsClone.removeClass('product-details-absolute').addClass('product-details-hidden');
          } else {
            //$productDetails.addClass('product-details-hidden');
            if($('.mobile-hide').length > 0) {$('.mobile-hide').removeClass('hide');}
            //$productDetailsClone.removeClass('product-details-absolute').removeClass('product-details-hidden');
          }
        }
      }
    },
    customResize: function () {
          // gallery block height fix js start here
          if ($(window).width() < 768 ) {
            if($('.category-view-common').length >0 ) {
              var imageWidth = $('.category-view-common .category-block .category-image').width();
              $(".category-view-common .category-block .category-image").css({'min-height': imageWidth});

            }
          }
          // gallery block height fix js end here
    },
    customTap: function(){
      if ($(window).width() < 768 ) {
        $('.category-block').click(function() {
          var $box = $(this);
          $(this).addClass('active-hover');
          setTimeout(function(box) {
            return box.removeClass('active-hover');
           }, 5000, $box);
        });
      }
    },
    sendEnquireMail: function () {
      $(document).on('click', '.disabled', function(e) {
        e.preventDefault();
         var email = 'sales@tomaszdonocik.com';
         var subject = $(this).attr('data-product-title');
         window.top.location = 'mailto:' + email + '?subject=' + subject;
      });
    },
    backToTop: function () {
      // hide #back-top first
      $("#back-top").hide();
      // fade in #back-top
      $window.scroll(function () {
        if ($(this).scrollTop() > 100) {
          $('#back-top').fadeIn();
        } else {
          $('#back-top').fadeOut();
        }
      });

      // scroll body to 0px on click
      $('#back-top a').click(function () {
        $('body,html').animate({
          scrollTop: 0
        }, 800);
        return false;
      });
    },
    customFunction: function () {
    if ($(window).width() < 1365 ) {
      //Read more text appear.
      $('.product-des .readmore').click(function (event) {
          event.preventDefault();
          $(".truncate-text").hide();
          $('.fulltext').show();
          $(this).hide();
          $(".readless").show();
      });
      $('.product-des .readless').click(function (event) {
          event.preventDefault();
          $(".truncate-text").show();
          $('.fulltext').hide();
          $(this).hide();
          $(".readmore").show();
      });
    }
      // header notification close button code
      if ($.cookie('notificationBar') == 'closed') {
        $('.notification-bar').remove();
      }
      else {
        $('.notification-bar').show();
      }

      $('.notification-bar a.close').bind('click',function(){
        $.cookie('notificationBar', 'closed', {expires:1});
        $('.notification-bar').remove();
        $(".message-bar header").css('top', 0);
        var HeaderHeight = $("header").outerHeight();
          //$("body.message-bar").css('padding-top', HeaderHeight);
          $("body.homepage-front.message-bar").css('padding-top', 0);

      });
      // header notification code end

      // filter js start here
      if ($(window).width() < 981 ) {
          $('.search-filter h4').off().on('click',function(){
            $(this).parent().siblings().children('ul').slideUp();
            $(this).parent().siblings().children('h4').removeClass('active');
            $(this).next('ul').slideToggle();
            $(this).toggleClass('active');
            //alert("hihi");
            return false;
          });
      }

      if ($(window).width() < 768 ) {
          $('.mobile-navigation-inner li.site-nav--has-dropdown li').each(function() {
            if ($(this).hasClass('site-nav--active')) {
            $(this).parent('ul').slideToggle();
            }
          });
          $('.mobile-navigation-inner .site-nav--has-dropdown a.parent-nav').click(function(e) {
            $('.mobile-navigation-inner .site-nav--has-dropdown a').removeClass('active');
            //$('.mobile-navigation-inner .site-nav--has-dropdown a ul').slideUp();
            $(this).parent().siblings().children('ul').slideUp();
            $(this).next('ul').slideToggle();
            $(this).toggleClass('active');
          });

          $('.search-tab-section a.category-toggle').off().click(function() {
            $(this).next('ul').slideToggle();
            $(this).toggleClass('active');
            return false;
          });
      }

      // filter js end here
        //pages toggle
        $(' a.sidebar-toggle').click(function() {
          $(this).next('ul').slideToggle();
          $(this).toggleClass('active');
          return false;
        });

      // Sub nav parent link toggle
      $(' a.sub-nav-parent').click(function() {
        $(this).next('ul').slideToggle();
        $(this).toggleClass('active');
        return false;
      });
      // Sub nav parent link toggle
     /* $(' a.sub-nav-parent').click(function() {
        $(this).next('ul').slideToggle();
        $(this).toggleClass('active');
      });
      */
      $('.sidebar-tabs li.site-nav--has-dropdown li').each(function() {
        if ($(this).hasClass('site-nav--active')) {
        $(this).parent('ul').slideToggle();
        }
      });

      // show engraving message in pop-up on cart page.
      $('.engraving-link').click(function() {
        $("body").addClass("body-fade");
        var ids = $(this).attr('id');
        $("#cart-" + ids).addClass("active");
        $("#cart1-" + ids).addClass("active");
      });
      $('.popup-outer .engraving-cancel').click(function() {
        var ids = $(this).parent().parent().parent().attr('id');
        $("body").removeClass("body-fade");
        $("#" + ids).removeClass("active");
        $("#cart1-" + ids).removeClass("active");
      });

      // Add class in body if notification bar exists.
      if ($(".notification-bar").hasClass('free-ship')){
        $body.addClass('message-bar')
      }

     // Accordion
     var countclick = 0;
      $('.page-title h3.explore-data').off().on('click',function(){
        console.log('click');

        if($(this).hasClass("explore-down1")) {
          $(this).removeClass('explore-down1');
          $(".clear-filter").css('display', "none");
           $(".search-filter").slideUp("slow");
          //return false;
        }
        else {
          $(this).addClass('explore-down1');
          $(".clear-filter").css('display', "block");
          //alert("test");
          $(".search-filter").slideDown("slow");
          //return false;
        }
        countclick = countclick + 1;
        //alert(countclick);
        /*$(".search-filter").slideToggle( "slow", function() {
            // Animation complete.
        });*/
      });

     // sticky header start here

      // same height js start here
      $('.same-height').matchHeight();

      // Data table
      if($("#sizeCare").length) {
        $('#sizeCare').DataTable();
      }

      $('.list-view').click(function() {
        $("#collection-controls select").val("list").change();
        $("#collectionView").submit();
      });

      $('.grid-view').click(function() {
        $("#collection-controls select").val("grid").change();
        $(this).addClass("current");
        $('.list-view').removeClass("current");
        $("#collectionView").submit();
      });

      // little hint js start here
      $(document).on( "click",'.hint-button-popup-btn', function() {
        var handle = $(this).attr('id'),
        coll_name = $(this).attr('data-collection'),
        prod_name = $(this).attr('data-product-title'),
        elementProductUrl= '/products/' + handle + '.js';
        return $.getJSON(elementProductUrl, function(product) {
          //console.log(product);
          var product_data, product_tags = '', product_el = product_el || {};
          if(!product.id) { return false; }
          product_el.image_url = Shopify.resizeImage(product.featured_image, "768x768");
          $('.product-id').val(product.id);
          $('.product-coll').val(coll_name);
          $('.product-name').val(prod_name);
          $('.product-url').val(product.url);
          $('.product-image-url').val('https:' + product_el.image_url);
          $('.des-product-name').text(prod_name);
          $('.little-hint-product').attr("src", product_el.image_url);
          $("body").addClass("body-fade");
          if ($("#little-hint p.msg").length > 0) {
            $("#little-hint p.msg").remove();
          }
          $("#little-hint").addClass("active");

          return true;
        });
      });
      $('#little-hint .popup-cancel').click(function() {
        $("body").removeClass("body-fade");
        $("#little-hint").removeClass("active");
      });
      // little hint js end here

      // mobile navigation js start here
      $("header .main-navigation a.nav-toggle").click(function(e) {
        $(".mobile-navigation").css({'margin-left': '0px'});
        //$body.addClass("nav-open").addClass("body-fade");
         $body.addClass("nav-open").addClass("body-nav-fade no-scroll");
          //SLOVERS.initialize.customShiftOpen('right');
      });

      /*$("body.body-fade").after().click(function(event) {
        console.log('click on after');
        var $target = $(event.target);
      });
      $("body").click(function(event) {
          var $target = $(event.target);
          console.log($target);
          });*/
        $(document).on( "click", ".body-fade", function(event) {
          var $target = $(event.target);
          if($target.hasClass('nav-open')) {
            $("body").removeClass("nav-open").removeClass("body-fade");
            $(".mobile-navigation").css({'margin-left': '-75%'});
          }
        });
        // Mobile navigation overlay click
        $('.body-overlay').click(function() {
           $("body").removeClass("nav-open").removeClass("body-nav-fade no-scroll");
           $(".mobile-navigation").css({'margin-left': '-75%'});
           //SLOVERS.initialize.customShiftClose('right');
        });
        $('.nav-toggle-cancel').click(function() {
           $("body").removeClass("nav-open").removeClass("body-nav-fade no-scroll");
           $(".mobile-navigation").css({'margin-left': '-75%'});
           //SLOVERS.initialize.customShiftClose('right');
        });
    // mobile navigation js end here


    },
    productPopUpOpen:function(item) {
      var el = item.parent();
      return SLOVERS.initialize.productPopUp(el);
    },
    productPopUpClose:function() {
      $("body").removeClass("body-fade2");
      $("#fabrics-fetail").removeClass("active");
    },
    productPopUp: function(el){
      if($productPopUpEl.length > 0) {
        var element = el,
            elementProductType = element.attr('data-product-type'),
            elementProductHandle = element.attr('data-product-handle'),
            elementProductId = element.attr('data-product-id'),
            elementProductUrl= '/products/' + elementProductHandle + '.js';
        return $.getJSON(elementProductUrl, function(product) {
          var product_data, product_tags = '', product_el = product_el || {};
          if(!product.id) { return false; }
          if(product.tags.length) {
            product_tags ='<label>View alternate fabric colours:</label>';
            product_tags +='<div class="fabric-color">';
            $(product.tags).each(function( index, element ) {
              product_tags +='<a href="/collections/all/'+ element+'">'+ element +'</a> ';
            });
            product_tags +='</div>';
          }

          product_el.image_url = Shopify.resizeImage(product.featured_image, "600x600");

          product_data='<div class="alert-popup">';
          product_data+='<a onclick="SLOVERS.initialize.productPopUpClose()" class="alert-popup-cancel"><i>&nbsp;</i></a>';
          product_data+='<div class="width50 f_left">';
          product_data+='<img src="' + product_el.image_url+ '" alt="">';
          product_data+='</div>';
          product_data+='<div class="width50 f_left fabric-description">';
          product_data+='<h3>' + product.title + '</h3>';
          product_data+= product.description
          product_data+=product_tags;
          product_data+='<a href="/collections/all/'+ product.type+'" class="button">View Garments Available in this fabric</a>';
          product_data+='</div>';
          product_data+='</div>';
          $fabricsDetail.html(product_data);
          $("body").addClass("body-fade2");
          $("#fabrics-fetail").addClass("active");
          return true;
        });
      }
    },
    displayDetails: function(el){

    },
    swatch: function() {
      // color swatch
      if ($('.swatch :radio').length) {
        $('.swatch :radio').change(function() {
          var optionIndex = $(this).closest('.swatch').attr('data-option-index');
          var optionValue = $(this).val();
          $(this).closest('form').find('.single-option-selector').eq(optionIndex).val(optionValue).trigger('change');
        });
      }
    }
  };


  SLOVERS.cart = {
    init: function() {
      SLOVERS.cart.submitForm();

      $cartItem.on('click', function(e) {
        e.preventDefault();
        if($window.width() > 980) {
          return SLOVERS.cart.slideInCart();
        }
        else {
          window.location.href = '/cart';
        }
      });
      $miniCartBlock.on('mouseleave', function() {
        //return SLOVERS.cart.slideOutCart();
      });
      $('.minicart-popup-cancel').on('click', function(e) {
         e.preventDefault();
        return SLOVERS.cart.slideOutCart();
      });
      $recentlyAdded.mouseenter(function() {
        return SLOVERS.cart.stopResetTimer();
      });
    },
    submitForm: function(){
      if( $cartForm.length > 0 ) {
        $cartForm.submit(function() {
          SLOVERS.cart.addToCart($(this));
          return false;
        });
      }
    },

    toggleCartDropdown: function() {
      return $recentlyAdded.slideToggle('fast');
    },
    slideDownCartDropdown: function() {
      $recentlyAdded.slideDown('fast');
      return $("html, body").animate({
        scrollTop: 0
      });
    },
    openMobileModal: function() {
      return $recentlyAdded.removeClass('hide').fadeIn();
    },
    fadeInCartDropdown: function() {
      clearTimeout(cart_dropdown_timer);
      return SLOVERS.cart.cartItemPopUp();
    },
    fadeOutCartDropdown: function() {
      clearTimeout(cart_dropdown_timer);
      $body.removeClass('body-fade2');
      return $recentlyAdded.fadeOut('fast').addClass('hide');
    },
    slideInCart: function(){
      clearTimeout(cart_dropdown_timer);
      return SLOVERS.cart.cartItemPopUp();

    },
    slideOutCart: function(){
      clearTimeout(cart_dropdown_timer);
      $body.removeClass('body-fade');
      if ($(window).width() > 767 ) {
        $miniCartBlock.css({'margin-right': '-520px'});
      }
      else {
        $miniCartBlock.css({'margin-right': '-100%'});
      }
      $body.css({'left': '0'});
      $("header").css({'left': '0'});
      return true;
    },
    startTimer: function() {
      SLOVERS.initialize.customScroll();
      return cart_dropdown_timer = setTimeout((function() {
        //return SLOVERS.cart.slideOutCart();
      }), 4000);
    },
    stopResetTimer: function() {
      return clearTimeout(cart_dropdown_timer);
    },
    validateSize: function(cart_form) {
      if (cart_form.find('select option:selected').is(':disabled')) {
        cart_form.find('.dropdown').effect('shake', {
          'times': 2,
          'distance': 5
        }, 400);
        return false;
      }
      return true;
    },
    addToCart: function(cart_form) {
      if ($('.product-form__cart-submit').hasClass('disabled')) {
        SLOVERS.initialize.sendEnquireMail();
        return false;
      }

      return $.ajax({
        type: "POST",
        url: "/cart/add.js",
        dataType: "json",
        data: cart_form.serialize(),
        success: SLOVERS.cart.addToCartPass,
        error: SLOVERS.cart.addToCartFail
      });
    },
    removeFromCart: function(e) {
      var lineItem = e + 1;
      return $.ajax({
        type: "POST",
        url: "/cart/change.js",
        dataType: "json",
        async: false,
        data: "quantity=0&line=" + lineItem,
        success: function(e) {
          var row = lineItem -1;
          clearTimeout(cart_dropdown_timer);
          $('.cart-row-' + row).remove();
          SLOVERS.cart.cartItemPopUp();
        },
        error: SLOVERS.cart.addToCartFail
      });
    },
    removeFromCartPass: function(e) {
      clearTimeout(cart_dropdown_timer);
      $('.cart-row-' + e).remove();
      SLOVERS.cart.cartItemPopUp();
    },
    addToCartPass: function(product) {
      //console.log(product);
      // location.reload(true);
      if($window.width() < 981) {
        window.location.href = product.url;
      }else {
        return SLOVERS.cart.cartItemPopUp();
      }
    },
    addToCartFail: function(obj, status) {
      //console.log('fail');
      //console.log(obj);
      //console.log(obj.responseJSON.description);

      $('.recently-added .error').text(obj.responseJSON.description);
      $('.recently-added .error').show();
      $('.recently-added table').hide();
      $('.recently-added div.row').hide();
      //SLOVERS.cart.slideDownCartDropdown();
      return false;
      //return SLOVERS.cart.startTimer();
    },
    getProductOpt: function(elementProductUrl) {
      var opt = [];
      $.ajax({
        url: elementProductUrl,
        dataType: 'json',
        async: false,
        data: {format: "json"},
        success: function(product) {
        opt = [];
          $.each(product.options, function(i, item) {
            opt.push(item.name);
          });
        }
      });
      return opt;
    },
    cartItemPopUp: function() {
      var cart_item, cart_total, imgAssetUrl, imgAssetUrlExt;
      cart_item = {};
      cart_total = {};
      // Shopify.money_format = Currency.moneyFormats[theme.shop_currency].money_format;
      Shopify.money_format = Currency.moneyFormats[Shopify.currency.active].money_format;
      return $.getJSON("/cart.js", function(cart, textStatus) {
        var new_cart_row, new_mobile_item, top_cart_items, cart_items;
        if(cart.item_count < 1){
          $miniCartBlock.html('<a onclick="SLOVERS.cart.slideOutCart()" class="minicart-popup-cancel header-right-cancel"><i>&nbsp;</i></a><h3>Your Basket</h3><h3>You have no items in your shopping bag at the moment.</h3>');
          return SLOVERS.cart.startTimer();
        }
        //$cartCount.html(cart_total.quantity);

        cart_items = '<a onclick="SLOVERS.cart.slideOutCart()" class="minicart-popup-cancel header-right-cancel"><i>&nbsp;</i></a>';
        //cart_items += '<div class="scrollbars header-right-section"><script>$(document).ready(function() {$(".scrollbars").ClassyScroll();});</script>';

        cart_items += '<h3>Your Basket</h3>';
        cart_items += '<div class="scrollbars1">';
        cart_items += '<div class="mini-products-list-section">';
        cart_items += '<div class="minicart-wrapper">';
        cart_items += '<ul class="mini-products-list scrollbars">';
        var a_total = parseFloat(tax);
        var b_total = parseFloat(cart.total_price);
        var c_total = parseInt(a_total * b_total);
        cart_total.price = Shopify.formatMoney(c_total, Shopify.money_format);
        cart_total.quantity = cart.item_count;
        //console.log(cart.items);
        $( cart.items ).each(function( index, element ) {
          var product_options = '';
          var product_options1 = '';
          if(element.variant_options) {
            $(element.variant_options).each(function( i, el ) {
              if(el != 'Default Title') {
                for (var k in el) {
                  if (el[k]) {
                    product_options += '<p><label>Size: </label>'+ ' ' + el[k] +'</p>';
                  }
                }
              }
            });
          }
          if(element.properties) {
            $(element.properties).each(function( i, el ) {
              for (var k in el) {
                if (el[k]) {
                  product_options1 += '<p><label>' + k + ': </label>Yes</p>';
                }
                else {
                  product_options1 += '<p><label>' + k + ': </label>No</p>';
                }
              }
            });
          }
          cart_item.image_url = Shopify.resizeImage(cart.items[index].image, "compact");
          cart_item.image_url_mobi = Shopify.resizeImage(cart.items[index].image, "compact");
          cart_item.url = cart.items[index].url;
          cart_item.title = cart.items[index].title;
          cart_item.quantity = cart.items[index].quantity;
          var a = parseFloat(tax);
          var b = parseFloat(cart.items[index].price);
          var c = parseInt(a * b);
          cart_item.price = Shopify.formatMoney(c, Shopify.money_format);



          cart_items += '<li class="cart-row-' + index + '">';
          cart_items += '<a href="' + cart_item.url + '"><img src="' + cart_item.image_url + '" alt="' + cart_item.title + '"></a>';
          cart_items += '<div class="product-details">';
          cart_items += '<h4><a href="' + cart_item.url + '">' + cart_item.title + '</a></h4>'; // removed .substring(0, 25) after cart_item.title - evan@cooeecommerce.com
          //cart_items += product_options; // disabled by evan@cooeecommerce.com
          //cart_items += '<p><label>Size</label> G 1/2</p>';
          cart_items += '<p><label> Qty </label>' + cart_item.quantity + '</p>';
           cart_items += product_options1;
          cart_items += '<p><a class="button-link" onclick="SLOVERS.cart.removeFromCart(' + index +')">Remove</a>';
          cart_items += ' <span class="min-product-price">' + cart_item.price + '</span></p>';
          cart_items += '</div>';
          cart_items += '</li>';
        });
        cart_items += '</ul>';

        cart_items += '<div class="minicart-bottom">';
        //cart_items += '<div class="minicart-promocode">';
       // cart_items += '<div class="input-box">';
        //cart_items += '<input name="" type="text" placeholder="Enter your promo code">';
        //cart_items += '<button class="Subscribe-btn" title="Subscribe" type="submit">&nbsp;</button>';
       // cart_items += '</div>';
       // cart_items += '</div>';
        cart_items += '<div class="minicart-subtotal">';
        cart_items += '<h2>Subtotal</h2>';
        cart_items += '<div class="minicart-st-price">' + cart_total.price + '</div>';
        cart_items += '</div>';
        cart_items += '<div class="minicart-actions">';
        cart_items += '<button onclick="window.location.href=\'/cart\'" class="button width50 f_right" title="Checkout" type="button">Checkout</button>';
        cart_items += '<a href="/collections/all" class="continue-button button-link">Continue shopping</a>';
        cart_items += '</div>';
        cart_items += '<div class="delivery-box">';
        cart_items += '<p>' + minicart_description + '</p>';
        //cart_items += '<p>UK and EU customers - VAT is included in the total price.<br>International customers (outside of the EU) - Important duties and local taxes are not included and will be calculated on arrival. <br>Please note that payment will be required to release from customs.</p>';
        cart_items += '<p>All delivery requires signature </p>';
        cart_items += '<p>Do you have any enquiries?<br>';
        cart_items += '<a href="/pages/delivery-returns">Visit Help page</a><br>';
        cart_items += '<a href="mailto:contact@tomaszdonocik.com">Email Us</a>';
        cart_items += '</p>';
        cart_items += ' </div>';
        cart_items += '<ul class="payment-gateway-option">';
        cart_items += '<li><i class="paypal-icon">&nbsp;</i></li>';
        cart_items += '<li><i class="visa-icon">&nbsp;</i></li>';
        cart_items += '<li><i class="mastercard-icon">&nbsp;</i></li>';
        cart_items += '<li><i class="maestro-icon">&nbsp;</i></li>';
        cart_items += '<li><i class="cirrus-icon">&nbsp;</i></li>';
        cart_items += '<li><i class="amex-icon">&nbsp;</i></li>';
        cart_items += '</ul>';
        cart_items += '</div>';

        cart_items += '</div></div></div>';
        //cart_items += '<script>$(document).ready(function() {SLOVERS.initialize.customScroll();});</script>';

      //  cart_items += '<div class="button-set margin-top20">';
       // cart_items += '<button onclick="window.location.href=\'/cart\'" class="button width50 f_left" title="Cart" type="button">Cart</button>';
       // cart_items += '</div>';

        new_mobile_item = '<a href="' + cart_item.url + '">';
        new_mobile_item += '<img src="' + cart_item.image_url + '" alt="' + cart_item.title + '">';
        new_mobile_item += '</a>';
        $miniCartBlock.html(cart_items);
        //$cartCount.html(cart_total.quantity);
       $('.recently-added .error').hide();
       /*
        $('.recently-added, .recently-added div.row').show();
        if ($('#header-wrap .mobile-tools').is(":hidden")) {
          SLOVERS.cart.slideDownCartDropdown();
        } else {
          SLOVERS.cart.openMobileModal();
        }*/
        return SLOVERS.cart.startTimer();
      });
    }
  };

  SLOVERS.widget = {
    init: function(){
      SLOVERS.widget.submitForm();
      SLOVERS.widget.carousel();
      SLOVERS.widget.customCollectionFilters();
      SLOVERS.widget.popup('popup');
      SLOVERS.widget.quantityBox();
    },
    customCollectionFiltersOLD: function(){
      /* Product Tag Filters - Good for any number of filters on any type of collection page.
       Give you product tag filter select element a class of coll-filter.
       Give your collection select a class of coll-picker.
       Brought to you by Caroline Schnapp. */
      if ($collFilter.length > 0) {
        Shopify.queryParams = {};
        if (location.search.length) {
          for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
              Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
        jQuery('.coll-picker').change(function() {
          if (jQuery(this).val()) {
            location.href = '/collections/' + jQuery(this).val();
          }
          else {
            location.href = '/collections/all';
          }
        });
        jQuery('.clear-filter a').click(function() {
            if (coll_var.handle){
              location.href = '/collections/'+ coll_var.handle;
            }
            else {
              location.href = '/collections/all';
            }
        });
        var collFilters = $collFilter;
        collFilters.click(function() {
          delete Shopify.queryParams.page;
          var newTags = [];
          collFilters.each(function() {
            if (jQuery(this).is(":checked")) {
              //newTags.push(jQuery(this).val());
            }
          });
          //console.log(jQuery(this).val());
          newTags = jQuery(this).val();
          if (coll_var.handle){

            var newURL = '/collections/'+ coll_var.handle;
            if (newTags.length) {
              newURL += '/' + newTags;
            }
            var search = jQuery.param(Shopify.queryParams);
            if (search.length) {
              newURL += '&' + search;
            }
            location.href = newURL;
          }
          else {
            if (newTags.length) {
              Shopify.queryParams.constraint = newTags.join('+');
            }
            else {
              delete Shopify.queryParams.constraint;
            }
            location.search = jQuery.param(Shopify.queryParams);
          }
        });
      }
    },
    customCollectionFilters: function(){
      /* Product Tag Filters - Good for any number of filters on any type of collection page.
       Give you product tag filter select element a class of coll-filter.
       Give your collection select a class of coll-picker.
       Brought to you by Caroline Schnapp. */
      if ($collFilter.length > 0) {
        Shopify.queryParams = {};
        if (location.search.length) {
          for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
            aKeyValue = aCouples[i].split('=');
            if (aKeyValue.length > 1) {
              Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
            }
          }
        }
        jQuery('.coll-picker').change(function() {
          if (jQuery(this).val()) {
            location.href = '/collections/' + jQuery(this).val();
          }
          else {
            location.href = '/collections/all';
          }
        });
        jQuery('.clear-filter a').click(function() {
            if (coll_var.handle){
              location.href = '/collections/'+ coll_var.handle;
            }
            else {
              location.href = '/collections/all';
            }
        });
        var collFilters = $collFilter;
        collFilters.click(function() {
          delete Shopify.queryParams.page;
          var newTags = [];
          collFilters.each(function() {
            if (jQuery(this).is(":checked")) {
              //newTags.push(jQuery(this).val());
            }
          });
          newTags = jQuery(this).val();
          if (coll_var.handle){

            var newURL = '/collections/'+ coll_var.handle;
            if (newTags.length) {
              //newURL += '/' + newTags.join('+');
              newURL += '/' + newTags;
            }
            var search = jQuery.param(Shopify.queryParams);
            if (search.length) {
              newURL += '?' + search;
            }
            location.href = newURL;
          }
          else {
            if (newTags.length) {
              Shopify.queryParams.constraint = newTags.join('+');
            }
            else {
              delete Shopify.queryParams.constraint;
            }
            location.search = jQuery.param(Shopify.queryParams);
          }
        });
      }
    },
    popup: function(clazz) {
      var checkContentOverflow, closeDialog, eventListeners, fillPopupDialog, fillSizeChartDialog, getCustomClasses, getImage, getNewsletter,closePopup, getPageContent, getSocialIcons, getWrapper, hideMask, ieCenter, isExpired, mask, maskIsActive, modal, modal_clazz, openDialog, passesExpiration, resetExpiration, showMask, storeExpiration;
      modal = null;
      modal_clazz = clazz;
      mask = $('.popup-modal-mask');
      storeExpiration = function() {
        var date, expires, object, seconds_from_now;
        date = new Date();
        seconds_from_now = 1000 * 60 * 60 * 24 * popup_config.days_until;
        expires = date.setTime(date.getTime() + seconds_from_now);
        object = {
          expires: expires
        };
        return localStorage[popup_config.storage_key] = JSON.stringify(object);
      };
      resetExpiration = function() {
        localStorage.removeItem(popup_config.storage_key);
        return storeExpiration();
      };
      isExpired = function() {
        var expires, now, object;
        object = JSON.parse(localStorage[popup_config.storage_key]);
        expires = object.expires;
        now = new Date().getTime();
        if (parseFloat(expires - now) <= 0) {
          resetExpiration();
          return true;
        }
        return false;
      };
      passesExpiration = function() {
        var passed;
        passed = false;
        if (Storage === "undefined" || popup_config.days_until === "test_mode") {
          passed = true;
        } else if (typeof localStorage[popup_config.storage_key] === "undefined") {
          passed = true;
          storeExpiration();
        } else {
          passed = isExpired();
        }
        return passed;
      };
      maskIsActive = function() {
        return $('.popup-modal').is(':visible') || $('.modal-mask').length > 0 && $('.modal-mask').is(':visible');
      };
      showMask = function() {
        mask.show();
        return $body.addClass("modal-on body-fade");
      };
      hideMask = function() {
        mask.hide();
        return $body.removeClass("modal-on body-fade");
      };
      getImage = function() {
        if (popup_config.show_image_enabled !== true) {
          return "";
        }
        if (popup_config.image_link.length > 0) {
          return $('<div class="popup-image-1 width100 f_left"><a href="' + popup_config.image_link + '"><img src="' + popup_config.show_image_url + '" alt=""></a></div>');
        } else {
          return $('<div class="popup-image-1 width100 f_left">').append("<img src='" + popup_config.show_image_url + "' alt=''>");
        }
      };
      getNewsletter = function() {
        var subscribe_module, page_link;
        if (popup_config.newsletter_enabled === false) {
          return "";
        }

        if (popup_config.page_url.length > 0) {
          page_link = ' ' + '<a href="' + popup_config.page_url + '" class="link">' + popup_config.page_title + '</a>';
        }
        subscribe_module = $("<div id='subscribe_module' class='newsletter-inner'></div>")
        .append($("#mailing-list-module > h2").clone())
        .append($("#mailing-list-module > p").clone())
        .append($("#mailing-list-module #contact_form").clone())
        .append($("#mc-embedded-subscribe-form").clone())
        .append( "<p>" + popup_config.page_content + page_link + "</p>");

        return subscribe_module;
      };
      getSocialIcons = function() {
        if (popup_config.social_icons_enabled === false) {
          return "";
        }
        return $(".social-follow").clone();
      };
      getCustomClasses = function() {
        var class_list;
        class_list = "";
        class_list += popup_config.show_image_enabled === true ? " has-image" : " has-no-image";
        class_list += popup_config.page_content.length > 0 ? " has-page-content" : " has-no-page-content";
        class_list += popup_config.newsletter_enabled ? " has-newsletter" : " has-no-newsletter";
        class_list += popup_config.social_icons_enabled ? " has-social-icons" : " has-no-social-icons";
        class_list += " popup-outer active";
        return class_list;
      };
      getWrapper = function() {
        return '<div class="' + modal_clazz + ' popup-modal' + getCustomClasses() + '" id="homepage-newsletter" />';
      };
      getPageContent = function() {
        var page_content;
        page_content = null;
        if (popup_config.page_content.length < 1) {
          return "";
        }
        $.getJSON('/pages/' + popup_config.page_content + '.json', function(data, textStatus) {
          return page_content = "<div class='page-contents'>" + data.page.body_html + "</div>";
        });
        return page_content;
      };
      fillSizeChartDialog = function() {
        var dialog;
        if ($('.popup-modal.size-chart').length < 1) {
          dialog = {
            wrapper: getWrapper()
          };
          $body.append($(dialog.wrapper).append($('.size-chart')));
        }
        return openDialog();
      };
      closePopup = function(){
        return $('<button class="popup-modal-close popup-cancel"><i>&nbsp;</i></button>');
      };
      fillPopupDialog = function() {
        //console.log('get popup');
        var dialog, getInnerContent, render;
        dialog = {
          wrapper: getWrapper(),
          closePopup: closePopup(),
          newsletter: getNewsletter(),
          social_icons: getSocialIcons(),
          //image: getImage()
        };
        getInnerContent = function() {
          if (popup_config.page_content.length < 1 && popup_config.newsletter_enabled === false && popup_config.social_icons_enabled === false) {
            return "";
          }
          return $("<div class='newsletter-popup'/>").append(dialog.body,dialog.closePopup, dialog.newsletter, dialog.social_icons);
        };
        render = function() {
          $body.append($(dialog.wrapper));
          $('.slideshow').slick('slickPause');
          $('<div class="popup-center"><div class="alert-popup"></div></div>').appendTo(".popup-outer" );
          $('.alert-popup').append(dialog.image, getInnerContent());
          return openDialog();
        };
        if (popup_config.page_content.length > 0) {
            return render();
          //return $.getJSON('/pages/' + popup_config.page_content + '.json', function(data, textStatus) {});
        } else {
          return render();
        }
      };
      checkContentOverflow = function() {
        return setTimeout((function() {
          if (modal.length > 0 && $('.popup-modal-mask').is(':visible')) {
            return modal.imagesLoaded(function() {
              if (modal.outerHeight() >= $window.height()) {
                return $body.addClass('modal-unfix');
              } else {
                return $body.removeClass('modal-unfix');
              }
            });
          }
        }), 0);
      };
      ieCenter = function() {
        return modal.css({
          marginTop: -(modal.outerHeight() * 0.5) + "px",
          marginLeft: -(modal.outerWidth() * 0.5) + "px"
        });
      };
      openDialog = function() {
        $('.slideshow').slick('slickPause');
        modal = $('div[class*="' + modal_clazz + '"]');
        if ($("html").hasClass("ie9")) {
          ieCenter();
        }
        eventListeners();
        modal.addClass("opened").removeClass("closed");
        checkContentOverflow();
        return showMask();
      };
      eventListeners = function() {
        var removeAnimation;
        removeAnimation = function(event) {
          if (event.originalEvent.animationName === 'modal-close') {
            if (modal_clazz === 'popup') {
              return modal.remove();
            } else {
              return modal.removeClass('closed, completed');
            }
          } else {
            return modal.addClass('completed').removeClass('opened');
          }
        };
        DOC.on('click', '.popup-modal', function(e) {
          e.stopPropagation();
          if (e.target === this) {
            return closeDialog();
          }
        });
        $('.popup-modal-close').click(closeDialog);
        mask.click(closeDialog);
        modal.on('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd', removeAnimation);
        $window.resize(checkContentOverflow);
        DOC.keydown(function(e) {
          if (modal.hasClass('completed') && e.keyCode === 27) {
            return closeDialog();
          }
        });
        return $('.popup-modal #contact_form').on('submit', function(event) {
          var form;
          form = this;
          modal = $(this).closest('.popup-modal');
          modal.find('.error, .success').remove();
          event.preventDefault();
          if (modal.find('input[type="email"]').val().length === 0) {
            modal.find('.inner').prepend('<p class="error">' + theme.translation.newsletter_email_blank + '</p>');
            return false;
          } else {
            modal.find('.inner > *').hide();
            modal.find('.inner').prepend('<p class="success">' + theme.translation.newsletter_success_message + '</p>').show();
            setTimeout(function() {
              return form.submit();
            }, 500);
          }
          return false;
        });
      };
      closeDialog = function() {
          //console.log('close popup');
        modal.addClass('closed').removeClass('completed').removeClass('opened').removeClass("active");
        $('.slideshow').slick('slickPlay');
        return hideMask();
      };
      if (modal_clazz !== 'popup') {
        return fillSizeChartDialog();
      } else {
        if (popup_config.enabled && passesExpiration() && (popup_config.page_content.length > 0 || popup_config.newsletter_enabled || popup_config.show_image_enabled || popup_config.social_icons_enabled)) {
          //console.log('open popup');
          return setTimeout((function() {
            //if (!(maskIsActive() === true || $('.popup-modal-mask').length < 1)) {
            if (!(maskIsActive() === true)) {
              return fillPopupDialog();
            }
          }), popup_config.seconds_until * 1000);
        }
      }
    },
    carousel: function(){
      if( !$().owlCarousel ) {
        console.log('carousel: Owl Carousel not Defined.');
        return true;
      }
      var $carousel = $('.carousel-widget:not(.customjs)');
      if( $carousel.length < 1 ){ return true; }
      $carousel.each( function(){
        var element = $(this),
          elementItems = element.attr('data-items'),
          elementItemsLg = element.attr('data-items-lg'),
          elementItemsMd = element.attr('data-items-md'),
          elementItemsSm = element.attr('data-items-sm'),
          elementItemsXs = element.attr('data-items-xs'),
          elementItemsXxs = element.attr('data-items-xxs'),
          elementLoop = element.attr('data-loop'),
          elementAutoPlay = element.attr('data-autoplay'),
          elementSpeed = element.attr('data-speed'),
          elementAnimateIn = element.attr('data-animate-in'),
          elementAnimateOut = element.attr('data-animate-out'),
          elementNav = element.attr('data-nav'),
          elementPagi = element.attr('data-pagi'),
          elementMargin = element.attr('data-margin'),
          elementStage = element.attr('data-stage-padding'),
          elementMerge = element.attr('data-merge'),
          elementStart = element.attr('data-start'),
          elementRewind = element.attr('data-rewind'),
          elementSlideBy = element.attr('data-slideby'),
          elementCenter = element.attr('data-center'),
          elementLazy = element.attr('data-lazyload'),
          elementVideo = element.attr('data-video'),
          elementRTL = element.attr('data-rtl');

        if( !elementItems ) { elementItems = 4; }
        if( !elementItemsLg ) { elementItemsLg = Number(elementItems); }
        if( !elementItemsMd ) { elementItemsMd = Number(elementItemsLg); }
        if( !elementItemsSm ) { elementItemsSm = Number(elementItemsMd); }
        if( !elementItemsXs ) { elementItemsXs = Number(elementItemsSm); }
        if( !elementItemsXxs ) { elementItemsXxs = Number(elementItemsXs); }
        if( !elementSpeed ) { elementSpeed = 250; }
        if( !elementMargin ) { elementMargin = 20; }
        if( !elementStage ) { elementStage = 0; }
        if( !elementStart ) { elementStart = 0; }

        if( !elementSlideBy ) { elementSlideBy = 1; }
        if( elementSlideBy == 'page' ) {
          elementSlideBy = 'page';
        } else {
          elementSlideBy = Number(elementSlideBy);
        }

        if( elementLoop == 'true' ){ elementLoop = true; } else { elementLoop = false; }
        if( !elementAutoPlay ){
          elementAutoPlay = false;
          var elementAutoPlayTime = 0;
        } else {
          var elementAutoPlayTime = Number(elementAutoPlay);
          elementAutoPlay = true;
        }
        if( !elementAnimateIn ) { elementAnimateIn = false; }
        if( !elementAnimateOut ) { elementAnimateOut = false; }
        if( elementNav == 'false' ){ elementNav = false; } else { elementNav = true; }
        if( elementPagi == 'false' ){ elementPagi = false; } else { elementPagi = true; }
        if( elementRewind == 'true' ){ elementRewind = true; } else { elementRewind = false; }
        if( elementMerge == 'true' ){ elementMerge = true; } else { elementMerge = false; }
        if( elementCenter == 'true' ){ elementCenter = true; } else { elementCenter = false; }
        if( elementLazy == 'true' ){ elementLazy = true; } else { elementLazy = false; }
        if( elementVideo == 'true' ){ elementVideo = true; } else { elementVideo = false; }
        if( elementRTL == 'true' || $body.hasClass('rtl') ){ elementRTL = true; } else { elementRTL = false; }

        element.owlCarousel({
          margin: Number(elementMargin),
          loop: elementLoop,
          stagePadding: Number(elementStage),
          merge: elementMerge,
          startPosition: Number(elementStart),
          rewind: elementRewind,
          slideBy: elementSlideBy,
          center: elementCenter,
          lazyLoad: elementLazy,
          nav: elementNav,
          navText: ['<i class="icon-angle-left"></i>','<i class="icon-angle-right"></i>'],
          autoplay: elementAutoPlay,
          autoplayTimeout: elementAutoPlayTime,
          autoplayHoverPause: true,
          dots: elementPagi,
          smartSpeed: Number(elementSpeed),
          fluidSpeed: Number(elementSpeed),
          video: elementVideo,
          animateIn: elementAnimateIn,
          animateOut: elementAnimateOut,
          rtl: elementRTL,
          responsive:{
            0:{ items:Number(elementItemsXxs) },
            480:{ items:Number(elementItemsXs) },
            768:{ items:Number(elementItemsSm) },
            992:{ items:Number(elementItemsMd) },
            1200:{ items:Number(elementItemsLg) }
          },
          onInitialized: function(){
            SLOVERS.widget.owlCaptionInit();
          }
        });
      });
    },
    owlCaptionInit: function(){
      if( $owlCarouselEl.length > 0 ){
        $owlCarouselEl.each( function(){
          var element = $(this);
          if( element.find('.owl-dot').length > 0 ) {
            element.addClass('with-carousel-dots');
          }
        });
      }
    },
    quantityBox: function() {
      // Basic increment / decrement counter
      var $quantityInput = $('.quantity-box-input');

      // Don't let a manual entry exceed more than we have
      $quantityInput.on('change', function(e){
        var min = parseInt( $(this).attr('min') ),
            max = parseInt( $(this).attr('max') ),
            newVal = parseInt( $(this).val() );

        if( newVal > max ){
          $(this).val(max);
        } else if( newVal < min ){
          $(this).val(min);
        }
      });

      // Hitting enter within a field
      $quantityInput.keyup(function (e) {
        if (e.keyCode == 13) {
           var min = parseInt( $(this).attr('min') ),
            max = parseInt( $(this).attr('max') ),
            newVal = parseInt( $(this).val() );

          if( newVal > max ){
            $(this).val(max);
          } else if( newVal < min ){
            $(this).val(min);
          }
        }
      });

      // Increment
      $('.quantity-plus').on('click', function(e) {
          e.preventDefault();
          var ids = $(this).attr('data-plus');
          var inputBox =  $('.quantity-' + ids);
          var currentVal = parseInt( inputBox.val() );
          var maxVal = parseInt( inputBox.attr('max') );
          if (!isNaN(currentVal)) {
           inputBox.val(currentVal + 1);
           // Dont go over max
           if( parseInt( inputBox.val() ) > maxVal ){
              inputBox.val( maxVal );
           }
          } else {
            inputBox.val(1);
          }
      });

      // Decrement
      $('.quantity-minus').on('click', function(e) {
          e.preventDefault();
          var ids = $(this).attr('data-minus');
          var inputBox =  $('.quantity-' + ids);
          var currentVal = parseInt( inputBox.val() );
          if (!isNaN(currentVal) && currentVal > 1) {
            inputBox.val(currentVal - 1);
          } else {
            inputBox.val(1);
          }
      });
    },
    submitForm: function(){
      if( $littleHintel.length > 0 ) {
        $littleHintel.submit(function() {
          SLOVERS.widget.littleHintPopup($(this));
          return false;
        });
      }
    },
    littleHintPopup: function(hint_form) {
      $('.little-hint-popup .hint-msg').removeClass('hide');
      return $.ajax({
        type: "POST",
        crossDomain: true,
        url: "https://hint-popup.herokuapp.com/little-hint",
        dataType: "json",
        useDefaultXhrHeader: false,
        data: hint_form.serialize(),
        success: SLOVERS.widget.addToCartPass,
        error: SLOVERS.widget.addToCartFail
      });
    },
    addToCartPass: function(e) {
      if (e.status == 1) {
        //$littleHintel.first('h1').append('<p class="msg">' + e.msg + '</p>');
        $('.little-hint-popup .hint-msg h1').text(e.msg);
        $('.little-hint-popup .hint-msg').removeClass('hide');
        setTimeout( function(){
          $("body").removeClass("body-fade");
          $("#little-hint").removeClass("active");
          $('.little-hint-popup .hint-msg').addClass('hide');
          $littleHintel[0].reset();
        }, 3000);
      } else {
        $('.little-hint-popup .hint-msg h1').text(e.msg);
      }
      return false;
    },
    addToCartFail: function(obj, e) {
      //console.log(obj);
      //console.log(e);
      return false;
    }

  };

  SLOVERS.documentOnResize = {
    init: function(){
      SLOVERS.initialize.resizeProductDetails();
      SLOVERS.initialize.headerSpacing();
      SLOVERS.initialize.customFunction();
      var t = setTimeout( function(){
        SLOVERS.initialize.mainDisplayDimensions();
        SLOVERS.initialize.sameHeight();
      }, 500 );
      windowWidth = $window.width(),
      windowHeight= $window.height();


    }
  };

  SLOVERS.documentOnReady = {
    init: function(){
      SLOVERS.initialize.init();
      SLOVERS.initialize.headerSpacing();
      SLOVERS.cart.init();
      SLOVERS.widget.init();

    }
  };

  SLOVERS.documentOnLoad = {
    init: function(){
      //SLOVERS.initialize.stickyElements();
    }
  };

  SLOVERS.documentOnScroll = {
    init: function(){
      SLOVERS.initialize.repositionProductDetails();
    }
  };



  var $window = $(window),
    $body = $('body'),
    DOC = $(document),
    $wrapper = $('#wrapper'),
    $header = $('#header'),
    $headerWrap = $('#header-wrap'),
    $content = $('#content'),
    $container = $('.container'),
    $productPopUpEl = $('.product-popup'),
    $fabricsDetail = $('.fabricsDetail'),
    $collFilter = $('.coll-filter'),
    $littleHintel = $('#widget-little-hint'),
    $cartForm = $('.cart-form'),
    $cartCount = $('.cart-count'),
    $cartItem = $('.cart-item'),
    $miniCartBlock = $('.minicart-block'),
    $owlCarouselEl = $('.owl-carousel'),
    $recentlyAdded = $('.recently-added'),
    $searchItem = $('.search-item'),
    $miniSearchBlock = $(".minisearch-block"),
    $miniCartPopupCancel = $('.minicart-popup-cancel'),
    $footer = $('#footer'),
    windowWidth = $window.width(),
    windowHeight= $window.height(),
    $mainDisplayEl = $('.slideshow-wrapper');
  $(document).ready( SLOVERS.documentOnReady.init );
  $window.load( SLOVERS.documentOnLoad.init );
  $window.on( 'resize', SLOVERS.documentOnResize.init );
  $window.on( 'scroll', SLOVERS.documentOnScroll.init );
  $window.on('load', $.debounce(150, function() {
    SLOVERS.initialize.headerSpacing();
  }));
})(jQuery);
